__webpack_require__.p = "/assets/discovery/_next/";